module.exports = __webpack_public_path__ + "media/Dora.66d0e9a1.mp4";